import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from './dashboard.reducer';

export const selectDashboardCardsDataState = createFeatureSelector<DashboardState>('dashboard');

export const selectDashboardCardsData = createSelector(
  selectDashboardCardsDataState,
  (state: DashboardState) => state.data
);

export const selectDashboardCardsDataLoading = createSelector(
    selectDashboardCardsDataState,
    (state: DashboardState) => state.loading
);

export const selectDashboardCardsDataError = createSelector(
    selectDashboardCardsDataState,
    (state: DashboardState) => state.error
);

export const selectDashboardGraphStatsData = createSelector(
  selectDashboardCardsDataState,
  (state: DashboardState) => state.graphStats
);

export const selectDashboardGraphStatsDataLoading = createSelector(
    selectDashboardCardsDataState,
    (state: DashboardState) => state.loading
);

export const selectDashboardGraphStatsDataError = createSelector(
    selectDashboardCardsDataState,
    (state: DashboardState) => state.error
);
